module.exports = __webpack_public_path__ + "static/media/banner-3.d3778548.jpg";